import { useEffect, useRef } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('ar_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
    sessionStorage.setItem('ar_session_id', sessionId);
  }
  return sessionId;
};

// Track event function
export const trackEvent = async (eventType, page, additionalData = {}) => {
  try {
    await axios.post(`${API}/analytics/track`, {
      event_type: eventType,
      page: page,
      referrer: document.referrer || '',
      user_agent: navigator.userAgent,
      session_id: getSessionId(),
      ...additionalData
    });
  } catch (e) {
    // Silently fail - analytics shouldn't break the app
    console.debug('Analytics tracking failed:', e);
  }
};

// Hook for automatic page view tracking
export const usePageTracking = () => {
  const tracked = useRef(new Set());
  
  useEffect(() => {
    const page = window.location.pathname;
    
    // Only track once per page per session
    if (!tracked.current.has(page)) {
      tracked.current.add(page);
      trackEvent('page_view', page);
    }
  }, []);
};

// Booking funnel tracking
export const trackBookingStarted = () => trackEvent('booking_started', window.location.pathname);
export const trackBookingStep = (step) => trackEvent(`booking_step_${step}`, window.location.pathname);
export const trackBookingCompleted = () => trackEvent('booking_completed', window.location.pathname);

export default { trackEvent, usePageTracking, trackBookingStarted, trackBookingStep, trackBookingCompleted };
